import PropTypes from "prop-types"
import { useCallback } from "react"
import { useSelector } from "react-redux"

import { openModal } from "components/modal"
import { IS_CA, IS_JEWLR } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"

import { ActionBtn, Text, ShipDate } from "./components"

const DeliveryMessage = ({ delivery, holidayStyle, showPeriod = false }) => {
  if (!delivery) return null

  const isRange = !!delivery.date_range

  return (
    <Text>
      {isRange ? (
        <>
          {"Get it "}
          <ShipDate holidayStyle={holidayStyle}>
            {delivery.date_range[0]}
          </ShipDate>
          {" to "}
          <ShipDate holidayStyle={holidayStyle}>
            {delivery.date_range[1]}
          </ShipDate>
        </>
      ) : (
        <>
          {"Get it by "}
          <ShipDate holidayStyle={holidayStyle}>{delivery.date}</ShipDate>
        </>
      )}
      {" with "}
      <ShipDate holidayStyle={holidayStyle}>{delivery.type}</ShipDate>
      {showPeriod && "."}
    </Text>
  )
}

DeliveryMessage.propTypes = {
  delivery: PropTypes.shape({
    date: PropTypes.string,
    date_range: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
  }),
  holidayStyle: PropTypes.bool,
  showPeriod: PropTypes.bool,
}

const ShipText = () => {
  const hasDiamondSelector = useSelector(
    (state) => state.wizard.hasDiamondSelector
  )
  const ship = useSelector((state) => state.wizard.shipping.main)
  const holidayDelivery = ship?.available_holiday_delivery

  const is_ca = IS_CA()
  const holidayStyle = showHolidayShippingInfoPDP() && holidayDelivery

  const showShippingInfo = useCallback(() => openModal("#shipping-info"), [])

  if (ship.view_type === "OUT_OF_STOCK") {
    return (
      <Text>
        We&apos;re sorry, this item is currently unavailable. Please check back
        soon!
      </Text>
    )
  }

  if (ship.delivery_dates?.length > 0) {
    const isMultiple = ship.delivery_dates.length > 1

    return (
      <>
        {ship.delivery_dates.map((delivery, index) => (
          <DeliveryMessage
            delivery={delivery}
            holidayStyle={holidayStyle}
            key={index}
            showPeriod={!isMultiple}
          />
        ))}
        {is_ca && !hasDiamondSelector && (
          <>
            {isMultiple ? (
              <Text>
                Your exact delivery dates will be calculated at checkout
              </Text>
            ) : (
              <div>
                <ActionBtn onClick={showShippingInfo}>
                  Change your postal code
                </ActionBtn>
              </div>
            )}
          </>
        )}
      </>
    )
  }

  if (ship.delivery_date_range) {
    return (
      <>
        <DeliveryMessage
          delivery={{
            date_range: ship.delivery_date_range,
            type: `${IS_JEWLR() ? "Free" : "Standard"} Shipping`,
          }}
          holidayStyle={holidayStyle}
          showPeriod
        />
        <Text>Your exact delivery dates will be calculated at checkout</Text>
      </>
    )
  }

  // Default no ship methods returned
  return (
    <Text>
      Get it by <ShipDate holidayStyle={holidayStyle}>{ship.esd}</ShipDate>.
    </Text>
  )
}

export default ShipText
